import { z } from "zod";

export const zContentLangInfo = z.object({
  view: z.literal("ContentLangInfo"),
});
export type ZContentLangInfo = z.infer<typeof zContentLangInfo>;
